const sharesTransferExcelModalSteps = {
  UPLOAD: 'upload',
  PREVIEW: 'preview',
} as const;

export type SharesTransferExcelModalStep =
  (typeof sharesTransferExcelModalSteps)[keyof typeof sharesTransferExcelModalSteps];

export default sharesTransferExcelModalSteps;
